module.exports = __webpack_public_path__ + "img/image (18).75986f53.jpg";